// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan[data-v-74170b63], h4[data-v-74170b63] {\n\tcolor: white;\n}\nh4[data-v-74170b63] {\n\tpadding-bottom: 3%;\n\tpadding-top: 3%;\n}\n", ""]);
// Exports
module.exports = exports;
